import type { ReactNode } from 'react';
import tw from 'tailwind-styled-components';
import type { CombinedType, FieldType } from '../../../types/EvalancheTypes';
import { componentMap } from '../componentMap';

const customFields = ['form_EMAIL'];

const hiddenFields = ['form_IMAGE', 'form_HIDDEN'];

const Container = tw.div`
  flex
  flex-col
  w-full
  items-center
`;

export const CombinedInputs = ({
  field,
  formikProps,
}: {
  field: CombinedType;
  formikProps: any;
}): ReactNode => (
  <Container>
    {field?.fields?.map((subField: FieldType) => {
      let FieldComponent: any;
      if (customFields.includes(subField.name)) {
        FieldComponent = componentMap[subField.name as keyof typeof componentMap];
      }
      FieldComponent = componentMap[subField.type as keyof typeof componentMap];
      if (FieldComponent) {
        return (
          <FieldComponent
            key={subField.name}
            field={subField}
            formikProps={formikProps}
            isHidden={hiddenFields.includes(subField.name) || subField.hidden}
          />
        );
      }

      return null;
    })}
  </Container>
);
